var map = {
	"./African.png": 5854,
	"./American.png": 2553,
	"./Asian.png": 8925,
	"./Bakery.png": 5574,
	"./Barbecue.png": 2211,
	"./Bento.png": 8229,
	"./Big Portion.png": 9905,
	"./Breakfast.png": 9095,
	"./British.png": 5559,
	"./Brunch.png": 5133,
	"./Burger.png": 143,
	"./Chicken.png": 8695,
	"./Chinese.png": 4279,
	"./Cold Drink.png": 7405,
	"./Comfort Food.png": 5909,
	"./Dessert.png": 3746,
	"./French.png": 1922,
	"./Fusion.png": 1219,
	"./Halal.png": 7374,
	"./Hot Drink.png": 5094,
	"./Indian.png": 7533,
	"./Italian.png": 5608,
	"./Japanese.png": 8490,
	"./Korean.png": 2691,
	"./Main.png": 2962,
	"./Meat.png": 2282,
	"./Mexican.png": 9914,
	"./Noodles.png": 6712,
	"./Nuts.png": 6458,
	"./Organic.png": 5584,
	"./Other.png": 4525,
	"./Pasta.png": 2982,
	"./Plant.png": 9419,
	"./Platter.png": 2505,
	"./Rice.png": 1387,
	"./Salad.png": 6907,
	"./Seafood.png": 816,
	"./Snack.png": 408,
	"./Soup.png": 7120,
	"./Spanish.png": 1757,
	"./Spicy.png": 3707,
	"./Starter.png": 5402,
	"./Steak.png": 5455,
	"./Sushi.png": 4811,
	"./Thai.png": 9990,
	"./Trendy.png": 571,
	"./Turkish.png": 3688,
	"./Value for Money.png": 8895,
	"./Vegan.png": 3355,
	"./Vegetarian.png": 1133,
	"./Wrap.png": 98,
	"./extra/Chef.png": 9202,
	"./extra/Chevron_Up.png": 1338,
	"./extra/Cookbook.png": 5262,
	"./extra/Funnel.png": 7141,
	"./extra/Happy.png": 2633,
	"./extra/Search.png": 4243,
	"./extra/Two_Hands.png": 9555
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6003;